import { useDispatch } from 'react-redux';
import { useAppSelector } from 'src/stores';
import { ICauHinhHeThong } from 'src/types/CauHinhHeThong.type';
import { setCauHinhHeThong } from './CauHinhHeThong.slice';

export default function useCauHinhHeThong() {
  const dispatch = useDispatch();
  const cauHinh = useAppSelector((state) => state.cauHinhHeThong);

  const datCauHinh = (cauHinh: ICauHinhHeThong[]) => {
    dispatch(setCauHinhHeThong(cauHinh));
  };

  const clear = () => {
    datCauHinh([]);
  };

  return {
    cauHinh,
    datCauHinh,
    clear,
  };
}
